import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class FooterRequestParams extends BaseApiRequestParams {
  sportTypeId: Number;

  constructor(sportTypeId: Number) {
    super('footer/');

    this.sportTypeId = sportTypeId;
  }

  get sportsParam() {
    return this.sportTypeId ? `&sportTypeId=${this.sportTypeId}` : '';
  }

  toString(): String {
    return super.toString() + this.sportsParam;
  }

  equals(model: FooterRequestParams): * {
    let equals = super.equals(model);

    equals &= this.sportsParam === model.sportsParam;

    return equals;
  }
}